import './App.scss';
import { ProviderContext } from './contexts/provider.context';
import { BrowserRouter, Route, Routes, useNavigate, useLocation } from "react-router-dom";
import LoginComponent from './components/login/login.component';
import DashboardComponent from './components/dashboard/dashboard.component';
import CheckLoginComponent from './shared/checking-authen/checking-authen.component';
import { useCallback, useEffect, useState } from 'react';
import BG_GRADIENT_1 from "./assets/svg/bg-circle-gradient-1.svg";
import BG_GRADIENT_2 from "./assets/svg/bg-circle-gradient-2.svg";
import ProfileSCModel from './model/profile.model';
import Layout from './shared/layout/layout.component';
import ChooseCompanyComponent from './components/choose-company/choose-company.component';
import JobQuestionListComponent from './components/job-questions-list/job-question-list.component';
import CreateJobQuestionComponent from './components/create-job-question/create-job-question.component';
import JobQuestionDetail from './components/job-questions-list/job-question-detail/job-question-detail.component';
import CandidateDetailPage from './components/candidate-detail/candidate-detail.page';
import StandardQuesstionComponent from './components/standard-question/standard-question.component';
import { LanguageProvider } from './contexts/language.context';
import CreateStdAssessmentFromUrl from './components/standard-question/create-standard-question-from-url/create-standard-question-from-url.component';
import RegisterComponent from './components/register/register.component';
import NotFoundPage from './components/not-found/not-found.component';
import CreditHistoryComponent from './components/credit-history/credit-history.component';
import PublicReport from './components/public-report/public-report.component';
import SettingsComponent from './components/settings/settings.component';
import InviteHrUserComponent from './components/invite-hr-user/invite-hr-user.component';
import InterviewerListComponent from './components/interviewers/interviewer-list.component';
import CreateGeneralQuestionComponent from './components/general-question/create-general-question.component';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
// if (process.env.NODE_ENV === "production") {
//   console.log = () => {};
//   console.debug = () => {};
//   console.info = () => {};
//   console.warn = () => {};
//   console.error = () => {};
// }

function AppContent({
  profileModel,
  setProfileModel,
  menuActive,
  setMenuActive,
  companyCreditsVersion,
  refreshCompanyCredits,
  theme
}: any) {
  const location = useLocation();
  const isPublicReport = location.pathname.startsWith("/public-report");
  return (
    <div className="App">
      {/* Only show backgrounds if not on public-report page */}
      {!isPublicReport && <>
        <div className='bg-template-gradient-1'></div>
        <div className='bg-template-gradient-1-2'></div>
        <div className='bg-template-gradient-2'></div>
        <div className='bg-template-gradient-2-1'></div>
      </>}
      <LanguageProvider>
        <ProviderContext.Provider
          value={{
            profileModel, setProfileModel,
            menuActive, setMenuActive,
            companyCreditsVersion,
            refreshCompanyCredits,
          }}
        >
          <Routes>
            <Route path="/" element={<LoginComponent />} />
            <Route path="/login" element={<LoginComponent />} />
            <Route path="/checking" element={<CheckLoginComponent />} />
            <Route path="/choose-company" element={<ChooseCompanyComponent />} />
            <Route path="/:company_id/register-company" element={<RegisterComponent />} />
            <Route path="/:company_id" element={<Layout />}>
              {/* Define routes for the right-side content */}
              <Route index element={<JobQuestionListComponent />} />
              <Route path="/:company_id/job-questions-list" element={<JobQuestionListComponent />} />
              <Route path="/:company_id/interviewers" element={<InterviewerListComponent />} />
              <Route path="/:company_id/credit-history" element={<CreditHistoryComponent />} />
              <Route path="/:company_id/settings" element={<SettingsComponent />} />
              <Route path="/:company_id/invite-hr-users" element={<InviteHrUserComponent />} />
              <Route path="/:company_id/company-questions-management" element={<StandardQuesstionComponent />} />
              <Route path="/:company_id/company-questions-management/create-from-url" element={<CreateStdAssessmentFromUrl />} />
              <Route path="/:company_id/job/:interview_id" element={<JobQuestionDetail />} />
              <Route path="/:company_id/job/:interview_id/:candidate_id" element={<CandidateDetailPage />} />
              <Route path="/:company_id/create-job-questions" element={<CreateJobQuestionComponent />} />
              <Route path="/:company_id/create-general-questions" element={<CreateGeneralQuestionComponent />} />
              <Route path="/:company_id/edit-general-questions/:job_question_id" element={<CreateGeneralQuestionComponent />} />
            </Route>
            <Route path="/public-report/:reportId" element={<PublicReport />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </ProviderContext.Provider>
      </LanguageProvider>
    </div>
  );
}

function App() {
  const [profileModel, setProfileModel] = useState<ProfileSCModel>();
  const [menuActive, setMenuActive] = useState(1);
  const [companyCreditsVersion, setCompanyCreditsVersion] = useState(0);
  const refreshCompanyCredits = useCallback(() => {
    setCompanyCreditsVersion((v) => v + 1);
  }, []);

  // Create a custom theme for MUI components
  const theme = createTheme({
    palette: {
      primary: {
        main: '#007bff',
      },
      secondary: {
        main: '#6c757d',
      },
    },
    typography: {
      fontFamily: 'LINESeedSansTH_Rg, Arial, sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AppContent
          profileModel={profileModel}
          setProfileModel={setProfileModel}
          menuActive={menuActive}
          setMenuActive={setMenuActive}
          companyCreditsVersion={companyCreditsVersion}
          refreshCompanyCredits={refreshCompanyCredits}
          theme={theme}
        />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
